interface PortalCustomBodyStyleProps {
  customStyle: string | undefined;
}

export function PortalCustomBodyStyle({ customStyle }: PortalCustomBodyStyleProps) {
  if (!customStyle) {
    return null;
  }
  return (
    <div
      id="custom-style"
      dangerouslySetInnerHTML={{
        __html: customStyle,
      }}
    />
  );
}
